
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 168.61 107.3"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"168.61","height":"107.3","rx":"7.94","fill":"#f15a24"}}),_c('path',{attrs:{"fill":"#333","d":"M0 25.09h168.61v9.99H0z"}}),_c('path',{attrs:{"d":"M51 85.93H25.65a8.2 8.2 0 01-8.24-8.16v-11.7a8.2 8.2 0 018.24-8.16H51a8.2 8.2 0 018.24 8.16v11.7A8.2 8.2 0 0151 85.93zM25.65 60.66a5.44 5.44 0 00-5.45 5.4v11.7a5.44 5.44 0 005.45 5.4H51a5.44 5.44 0 005.46-5.4v-11.7a5.44 5.44 0 00-5.46-5.4zm121.76 1.9H78.9a2.07 2.07 0 01-2.07-2.07 2.07 2.07 0 012.07-2.07h68.51a2.07 2.07 0 012.07 2.07 2.07 2.07 0 01-2.07 2.07zm-36.33 16.55H78.9A2.07 2.07 0 0176.83 77a2.07 2.07 0 012.07-2h32.19a2.07 2.07 0 012.07 2 2.07 2.07 0 01-2.07 2.07z","fill":"#fff"}})])
          )
        }
      }
    